import { render, staticRenderFns } from "./Usuarios.vue?vue&type=template&id=565559a1&"
import script from "./Usuarios.vue?vue&type=script&lang=js&"
export * from "./Usuarios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports